import React, { useLayoutEffect, useState } from 'react';
import { useEmulator } from '../firebase';
import LocalUserSwitcher from './LocalUserSwitcher';

function LoginScreen({ onSignIn, onTestSignIn }) {
  const [isLoading, setIsLoading] = useState(false);
  const isLocalHost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const isVaultAccess =
    isLocalHost &&
    (new URLSearchParams(window.location.search).get('access') === 'kx92j' ||
    window.__IS_VAULT_ACCESS);

  const hasAutoSignedIn = React.useRef(false);

  useLayoutEffect(() => {
    if (isVaultAccess && !hasAutoSignedIn.current) {
      hasAutoSignedIn.current = true;
      onTestSignIn();
    }
  }, [isVaultAccess, onTestSignIn]);

  return (
    <div
      className="h-screen w-full flex items-center justify-center bg-zinc-50 font-sans antialiased px-4"
      style={{ background: 'radial-gradient(circle at top, #f4f4f5 0%, #ffffff 100%)' }}
    >
      <div className="max-w-md w-full px-8 py-16 bg-white rounded-3xl shadow-[0_20px_60px_-15px_rgba(0,0,0,0.12)] border border-zinc-100 flex flex-col items-center text-center">
        {/* Branding */}
        <h1 className="text-5xl font-black text-zinc-900 mb-2 tracking-tighter">
          Now You Tree Me {useEmulator ? '🌵' : '🌴'}
        </h1>
        <p className="text-zinc-400 mb-12 text-sm font-light leading-relaxed max-w-[240px]">
          The ultimate tiki workspace for your perfect projects.
        </p>

        {/* Action Button - The Centerpiece */}
        <div className={`w-full space-y-4 ${isLoading ? 'opacity-50 pointer-events-none' : ''}`}>
          <button
            onClick={onSignIn}
            className="w-full flex items-center justify-center gap-4 px-8 py-6 bg-zinc-900 border-2 border-zinc-900 rounded-2xl text-white font-black hover:bg-black hover:shadow-2xl active:scale-[0.96] transition-all duration-300 group/btn shadow-xl"
          >
            <div className="bg-white p-2 rounded-lg">
              <svg className="w-6 h-6" viewBox="0 0 48 48">
                <path
                  fill="#EA4335"
                  d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
                />
                <path
                  fill="#4285F4"
                  d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
                />
                <path
                  fill="#FBBC05"
                  d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
                />
                <path
                  fill="#34A853"
                  d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
                />
                <path fill="none" d="M0 0h48v48H0z" />
              </svg>
            </div>
            <span className="text-xl tracking-tight">Sign in with Google</span>
          </button>

          {isVaultAccess && (
            <button
              id="v-btn-9"
              onClick={onTestSignIn}
              className="w-full py-4 bg-zinc-100 hover:bg-zinc-200 text-zinc-600 rounded-xl text-xs font-black uppercase tracking-widest transition-all border border-zinc-200"
            >
              Access Vault
            </button>
          )}

          {useEmulator && <LocalUserSwitcher onLoading={setIsLoading} />}
        </div>

        {/* Footer */}
        <div className="mt-12 pt-8 border-t border-zinc-50 w-full flex justify-center gap-4 text-[10px] text-zinc-300 uppercase tracking-[0.2em] font-black">
          <span>Secure</span>
          <span className="text-zinc-100">•</span>
          <span>Simple</span>
          <span className="text-zinc-100">•</span>
          <span>Tree-less</span>
        </div>
      </div>
    </div>
  );
}

export default LoginScreen;
